import unInstall from 'assets/image/auth-steps/unInstall.png'
import clsx from 'clsx'
import { AuthTemplate } from 'components/templates/authTemplate'
import { CONSTS } from 'config/objectConst'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui'

import css from './NoInstalled.module.scss'

const LEAD = `To perfom all actions on LinkedIn, You have to install ${CONSTS.PROJECT_NAME} Chrome Extension`,
	TITLE = `Install ${CONSTS.PROJECT_NAME} Chrome Extension`

const cn = AuthTemplate.cn

export const NoInstalled = () => (
	<AuthTemplate active={1}>
		<h1 className={cn.title}>{TITLE}</h1>

		<img
			alt={`Our mascot pink snail ${CONSTS.PROJECT_NAME} appears to melt into a puddle, with two googly eyes poking out from the liquid.
`}
			className={cn.image}
			height={157}
			src={unInstall}
			width={250}
		/>
		<p className={cn.text}>{LEAD}</p>

		<Button
			as='a'
			className={clsx(css.action, cn.action)}
			href={CONSTS.EXTENSION_INSTALL_URL}
			rel='noopener noreferrer'
			target='_blank'
			typography={typo.largeButton}
			variant='bordered'
		>
			Install
		</Button>
	</AuthTemplate>
)
